import appClient from "../../common/services/AppClient";
import { endpoints } from "../../../config";

export type WorkbenchNote = {
    id: string;
    text: string;
    authorName: string;
    createdAt: string;
};

export type WorkbenchNotesView = {
    subjectId: string;
    submissionId: string | null;
    submissionIdentifier: string | null;
    notes: WorkbenchNote[];
};

export type NoteSave = {
    requestId: string;
    text: string;
    expectedSubmissionId: string | null;
};

const url = (subjectId: string) =>
    `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/notes`;

export default class WorkbenchNotesService {
    get(subjectId: string) {
        return appClient.get<WorkbenchNotesView>(url(subjectId));
    }

    create(subjectId: string, note: NoteSave) {
        return appClient.post<WorkbenchNote>(url(subjectId), note);
    }
}
